/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 */

import { PropertyFeatures } from '@zcode/enums'
import type { Listable, Pin, Property } from '@zcode/state-type'

export const isExclusive = (item: Pick<Listable | Pin | Property, 'features'>) => {
  return !!item.features?.includes(PropertyFeatures.EXCLUSIVE)
}
